import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function Dashboard({ session }) {
  const navigate = useNavigate();

  async function handleLogout() {
    await supabase.auth.signOut();
    navigate('/login');
  }

  const opciones = [
    { emoji:'📅', titulo:'Caja Diaria', sub:'Registrá ventas por turno', path:'/caja-diaria', color:'#27AE60' },
    { emoji:'📋', titulo:'Historial', sub:'Ver cajas anteriores', path:'/historial', color:'#2471A3' },
    { emoji:'🏪', titulo:'Proveedores', sub:'Compras y deudas', path:'/proveedores', color:'#E67E22' },
    { emoji:'🧾', titulo:'Impuestos', sub:'Vencimientos y pagos', path:'/impuestos', color:'#D4AC0D' },
    { emoji:'👷', titulo:'Empleados', sub:'Sueldos y asistencia', path:'/empleados', color:'#6C3483' },
    { emoji:'📈', titulo:'Reportes PDF', sub:'Resumen y exportar', path:'/reportes', color:'#1ABC9C' },
  ];

  return (
    <div style={{ minHeight:'100vh', background:'#F2F3F4' }}>

      {/* Header */}
      <div style={{ background:'#1B2631', padding:'20px 32px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <div>
          <h1 style={{ color:'#fff', margin:0, fontSize:22 }}>🍽️ Local de Comidas</h1>
          <p style={{ color:'#aaa', margin:'4px 0 0', fontSize:13 }}>
            Bienvenida, {session?.user?.email}
          </p>
        </div>
        <button
          onClick={handleLogout}
          style={{ background:'transparent', border:'1px solid #555', color:'#aaa', padding:'8px 16px', borderRadius:8, cursor:'pointer', fontSize:13 }}
        >
          Cerrar sesión
        </button>
      </div>

      {/* Grid de opciones */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(250px, 1fr))', gap:20, padding:32 }}>
        {opciones.map((op, i) => (
          <div
            key={i}
            onClick={() => navigate(op.path)}
            style={{
              background:'#fff',
              borderRadius:12,
              padding:24,
              borderLeft:`4px solid ${op.color}`,
              cursor:'pointer',
              boxShadow:'0 2px 8px rgba(0,0,0,0.08)',
            }}
          >
            <div style={{ fontSize:32, marginBottom:8 }}>{op.emoji}</div>
            <div style={{ fontSize:16, fontWeight:'bold', color:'#1B2631', marginBottom:4 }}>{op.titulo}</div>
            <div style={{ fontSize:13, color:'#888' }}>{op.sub}</div>
          </div>
        ))}
      </div>

    </div>
  );
}